import React, { useEffect } from 'react';
import LanguageUtils from '../../utils/LanguageUtils';
import GTSOrderUnitDangerousGoods from '../../interfaces/output/gtsOrderUnitDangerousGoods';
import GenericStepper from '../common/widgets/genericStepper';
import UrlConstants from '../../constants/UrlConstants';
import { FormType } from '../../constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import WorkflowUtils from '../../utils/workflowUtils';
import { fetchGtsOrderUnitDangerousGoodsById, getGtsOrderUnitDangerousGood, isUpdatingGtsOrderUnitDangerousGood, updateGtsOrderUnitDangerousGoods } from '../../reducers/gtsDangerousGoodsReducer';
import GtsOrderUnitDangerosGoodsFormStep1 from './gtsOrderUnitDangerousGoodsFormStep1';
import GenericStep from '../../interfaces/common/genericStep';

interface IEditDangerousGoodsFormProps {
    gtsDangerousGoodsId?: number;
    gtsOrderUnitId?: number;
    steps: Array<number>;
    type: FormType;
}

const messages = {
    edit: LanguageUtils.createMessage('Edit dangerous good')
};

export default function DangerousGoodsForm(props: IEditDangerousGoodsFormProps): JSX.Element {
    const dispatch = useDispatch();
    const { gtsDangerousGoodsId, gtsOrderUnitId, steps, type } = props;
    const propsOrderUnitDangerousGood = useSelector(getGtsOrderUnitDangerousGood);
    const [orderUnitDangerousGood, setOrderUnitDangerousGood] = React.useState<GTSOrderUnitDangerousGoods>({ orderUnit: { id: gtsOrderUnitId } } as GTSOrderUnitDangerousGoods);
    const [redirectCondition, setRedirectCondition] = React.useState<boolean>(false);
    const propsIsUpdatingOrderUnitDangerousGood = useSelector(isUpdatingGtsOrderUnitDangerousGood);
    const prevIsUpdatingOrderUnitDangerousGood = WorkflowUtils.usePrevious<boolean>(propsIsUpdatingOrderUnitDangerousGood);
    
    useEffect(() => {
        const lastStep = steps[steps.length - 1];
        switch (lastStep) {
            case 1:
                if(prevIsUpdatingOrderUnitDangerousGood === true && !propsIsUpdatingOrderUnitDangerousGood) {
                    setRedirectCondition(true);
                }
                break;

            default:
        }
        
        return () => setRedirectCondition(false);
    }, [propsIsUpdatingOrderUnitDangerousGood]);
    
    useEffect(() => {
        if(gtsDangerousGoodsId) {
            dispatch(fetchGtsOrderUnitDangerousGoodsById(gtsDangerousGoodsId));
        }
    }, [dispatch]);
    
    useEffect(() => {
        if(propsOrderUnitDangerousGood.id) {
            setOrderUnitDangerousGood(propsOrderUnitDangerousGood);
        }

    }, [propsIsUpdatingOrderUnitDangerousGood, propsOrderUnitDangerousGood]);

    const onChangeUnitService = (attribute: string, value: any) => {
        const newOrderUnitDangerousGood = { ...orderUnitDangerousGood } as GTSOrderUnitDangerousGoods;
        (newOrderUnitDangerousGood as any)[attribute] = value;

        setOrderUnitDangerousGood(newOrderUnitDangerousGood);
    };

    const getSteps = () : GenericStep[] => [
        {
            id: 1,
            name: 'Edit details for gts order unit dangerous goods',
            content: <GtsOrderUnitDangerosGoodsFormStep1 onChange={onChangeUnitService} gtsDangerousGoods={orderUnitDangerousGood} />,
            onNext: () => {
                dispatch(updateGtsOrderUnitDangerousGoods(orderUnitDangerousGood));
            }
        } as GenericStep
    ];

    const getTitle = () : any => {
        switch (type) {
            case FormType.Edit:
                return messages.edit;
            default:
                throw new Error('Form type required');
        }
    };

    const includedSteps = getSteps().filter(step => steps.includes(step.id));

    const redirectTo = () : any => {
        switch (type) {
            case FormType.Edit:
                return `/${UrlConstants.UNIT_DANGEROUS_GOODS}/${gtsDangerousGoodsId}`;
            default:
                throw new Error('No route was found');
        }
    };

    return (
        <GenericStepper
            steps={includedSteps}
            name={getTitle()}
            redirectCondition={redirectCondition}
            redirectTo={redirectTo()}
        />
    );
}
  